/* eslint-disable */
export default {
  title: 'Son',
  dialButtonVolume: 'Volume du bouton de numérotation',
  ringtoneVolume: 'Volume de la sonnerie',
  callVolume: 'Volume de l’appel',
  muteCalls: 'Désactiver le son des appels',
  outputDevice: 'Périphérique de sortie',
  inputDevice: 'Périphérique d’entrée',
  micPermission: 'Autorisation de l’usage du microphone',
  noDevice: 'Aucun appareil',
  checkMicPermission: 'Vérifiez votre autorisation',
  micNoPermissionMessage:
    'L’application n’a pas l’autorisation d’utiliser le microphone',
  noLabel: 'Périphérique inconnu',
  notSetSinkIdTip:
    'Désolés, les autorisations actuelles dans votre navigateur ne sont pas définies de manière à nous autoriser l’accès à vos périphériques de sortie audio. {clickHereLink} pour voir comment régler les paramètres.',
  noLabelTip:
    'Désolés, les autorisations actuelles dans votre navigateur ne sont pas définies de manière à nous autoriser l’accès à vos périphériques d’entrée audio.',
  clickHere: 'Cliquez ici',
  defaultOutputDevice: 'Périphérique de sortie par défaut',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"dialButtonVolume"@#@ @source: @#@"Dial Button Volume"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone Volume"@#@
// @key: @#@"callVolume"@#@ @source: @#@"Call Volume"@#@
// @key: @#@"muteCalls"@#@ @source: @#@"Mute Calls"@#@
// @key: @#@"outputDevice"@#@ @source: @#@"Output Device"@#@
// @key: @#@"inputDevice"@#@ @source: @#@"Input Device"@#@
// @key: @#@"micPermission"@#@ @source: @#@"Microphone Permission"@#@
// @key: @#@"noDevice"@#@ @source: @#@"No device"@#@
// @key: @#@"checkMicPermission"@#@ @source: @#@"Check Permission"@#@
// @key: @#@"micNoPermissionMessage"@#@ @source: @#@"The app does not have permission to use microphone"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"notSetSinkIdTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio output devices. {clickHereLink} to see how to set up."@#@
// @key: @#@"noLabelTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio input devices."@#@
// @key: @#@"clickHere"@#@ @source: @#@"Click here"@#@
// @key: @#@"defaultOutputDevice"@#@ @source: @#@"Default output device"@#@
